import { DeleteOutlined, DownloadOutlined, EditOutlined, EyeOutlined, FilterFilled, PlusOutlined, SearchOutlined, SettingOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Checkbox, ConfigProvider, Input, Pagination, PaginationProps, Select, Table, TableColumnsType, TableProps } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import Layout from '../../../Layout';
import viVN from 'antd/locale/vi_VN';
import './style.scss'
import ModalCreateCar from './Component/Modal/ModalCreateCar';
import ModalEditCar from './Component/Modal/ModalEditCar';
import ModalManagerSegment from './Component/Modal/ModalManagerSegment';
import DrawerAddvance from './Component/Drawer/DrawerAddvance';
import DrawerInfoCar from './Component/Drawer/DrawerInfoCar';
import ModalDeleteManager from '../../../components/ModalDeleteManager';
import useToast from '../../../hook/useToast';
import useDebounce from '../../../hook/useDebounce';
import * as carApi from '../../../api/car/carApi';
import URL_CAR, { API_URL, LIMIT_EXPORT_EXCEL, URL_CAR_CATEGORY } from '../../../env';
import { carDefault, logoBrandDefault } from '../../../components/ExportImgFigma';
import { checkDisabledPermission, dataPagination, exportExcel, findChildIdByUrl, fommatSelectOption, getUserPermissions } from '../../../until';
import * as selectOptionsApi from '../../../api/selectOption/selectOptionsApi';
import * as attributeVehicleApi from '../../../api/attributeVehicle/attributeVehicleApi';
import useThrottle from '../../../hook/useThrottle';
import useLoading from '../../../hook/useLoading';
import { useSelector } from 'react-redux';
import { selectorMenu } from '../../../store/slices/menuSlice';
import { IRelative } from '../../../api/selectOptions/selectOptionsApi';
import ImportDataColorCar from '../../Customers/Component/ImportDataModal/ImportDataColorcar';
import { ResponseSuccessDataError, uploadFileCar } from '../../../api/customer/customerApi';
import ModalViewCar from './Component/Modal/ModalViewCar';
import { ColDef } from 'ag-grid-community';
import { AgGridReact } from 'ag-grid-react';
import { NodataTable } from '../../../components/NoDataTable';
import { NO_DATA } from '../../../services/data';
import { mod } from '@antv/util';
import { formatNumber } from '../../../services/mixin';
import { useLocation } from 'react-router-dom';
import { selectorPermission } from '../../../store/slices/permissionSlice';

const arrBrand: listBrand[] = [
  {
    id: 1,
    title: 'BMW',
    checked: false
  },
  {
    id: 2,
    title: 'MINI',
    checked: false
  },
  {
    id: 3,
    title: 'Peugeot',
    checked: false
  },
  {
    id: 4,
    title: 'Mazda',
    checked: false
  },
  {
    id: 5,
    title: 'KIA',
    checked: false
  }
]
interface listBrand {
  id: number;
  title: string;
  checked: boolean
}
interface DataType {
  key: React.Key;
  imgCar: string;
  clCar: string;
  codeCar: string;
  nameCar: string;
  logoBrand: string
  brand: string;
  segment: string;
  typeCar: string;
  yearManufacture: string | null;
  versionCar: string
  codeB7?: string
  modelVehicleTitle?: string
  groupVehicleTitle?: string
}


const VehicleList: React.FC = () => {
  
  useEffect(() => {
    document.title = 'THACO AUTO CRM';

    gCLCarCompany()
    // gCLAttributeVehicle()
    gCarLines()
    return () => {
      setFilterName(undefined)

      setIdCar(undefined)
      setselectedIdCar(new Set())
      setPagination({ current: 1, pageSize: 10, total: 0 })

      setListCar([])
    }

  }, []);

  const pushToast = useToast();
  const pushLoading = useLoading()
  const location = useLocation();
  const permissionSlice = useSelector(selectorPermission)
  const { add, edit, delete: isdelete, download, upload } = getUserPermissions(permissionSlice, location.pathname)

  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [isOpenCreateCar, setIsOpenCreateCar] = useState(false)
  const [isOpenEditCar, setIsOpenEditCar] = useState(false)
  const [isOpenViewCar, setIsOpenViewCar] = useState(false)
  const [isOpenSegment, setIsOpenSegment] = useState(false)
  const [isOpenAddvance, setIsOpenAddvance] = useState(false)
  const [isOpenDetailCar, setIsOpenDetailCar] = useState(false)
  const [IsOpenDeleteVehicle, setIsOpenDeleteVehicle] = useState(false)
  const [filterVisible, setFilterVisible] = useState(false);
  const [openModalUpload, setOpenModalUpload] = useState(false);
  const [fileData, setFileData] = useState({} as any)
  const [type, setType] = useState<string>("")


  const [selectedIdCar, setselectedIdCar] = useState<Set<number>>(new Set());

  const [filterName, setFilterName] = useState<string>()
  const [defaulFilter, setDefaultFilter] = useState<carApi.FilterCar>()

  const [idCar, setIdCar] = useState<number>()
  const [paginationTmp, setPaginationTmp] = useState<number>(1)
  const [pagination, setPagination] = useState({ current: paginationTmp, pageSize: 10, total: 0 });

  const [typeVehicle, setTypeVehicle] = useState<IRelative[]>([])// loại xe

  const [sLCategoryCar, setSLCategoryCar] = useState<selectOptionsApi.ICarCompany[]>([])
  const [sLAttributeVehicle, setSLAttributeVehicle] = useState<attributeVehicleApi.IAttributeVehicle[]>([])

  const [columnDefs, setColumnDefs] = useState(useMemo<ColDef<any>[]>(() => [
    {
      headerName: 'Hành động',
      headerComponentParams: {
        template: '<span class="w-full flex items-center justify-center">Hành động</span>'
      },
      field: 'action',
      colId: 'action',
      width: 180,
      resizable: false,
      suppressMovable: true,
      lockPosition: 'left',
      cellRenderer: (params: any) => {
        const { key } = params.data;
        return (
          <div className='d-flex gap-4 justify-center align-center  h-full'>
            <EyeOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${checkDisabledPermission(edit)}`}
              onClick={() => gInfoCar(key)}
            />
            <EditOutlined
              className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer  ${checkDisabledPermission(edit)}`}
              onClick={() => gInfoCar(key, false)}
            />
            <DeleteOutlined
              className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer ${checkDisabledPermission(isdelete)}`}
              onClick={() => openModalDeleteCar(Number(key))}
            />
          </div>
        );
      }
    },
    {
      headerName: 'Hình ảnh',
      field: 'imgCar',
      colId: 'imgCar',
      cellRenderer: (params: any) => {
        const { imgCar, key } = params.data;
        return (
          <div className='cursor-pointer' style={{ height: '100%', width: '60px' }} onClick={() => gDetailCar(Number(key))}>
            <img
              src={imgCar}
              alt="imgCar"
              className='object-fit-cover w-full h-full'
              onError={(e) => {
                e.currentTarget.src = carDefault;
              }}
            />
          </div>
        );
      },
      flex: 1
    },
    {
      headerName: 'Loại xe',
      field: 'clCar',
      colId: 'clCar',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-code'>{params.value || NO_DATA}</div>;
      },
      flex: 1
    },
    {
      headerName: 'Mã xe',
      field: 'codeCar',
      colId: 'codeCar',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-code'>{params.value || NO_DATA}</div>;
      },
      flex: 1
    },
    {
      headerName: 'Mã xe B7',
      field: 'codeB7',
      colId: 'codeB7',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-code'>{params.value || NO_DATA}</div>;
      },
      flex: 1
    },
    {
      headerName: 'Tên xe',
      field: 'nameCar',
      colId: 'nameCar',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-name'>{params.value || NO_DATA}</div>;
      },
      flex: 1
    },
    {
      headerName: 'Thương hiệu',
      field: 'brand',
      colId: 'brand',
      cellRenderer: (params: any) => {
        const { logoBrand, brand } = params.data;
        return (
          <div className='flex items-center gap-3 w-full'>
            <div className='w-6 h-6 flex items-center shrink-0'
               style={{
                  flexShrink: 0,
                }}
            >
              <img
                src={logoBrand}
                className='custom-page-css flex w-full h-full object-fit-cover'
                style={{
                  flexShrink: 0,
                }}
                alt='logoBrand'
                onError={(e) => {
                  e.currentTarget.src = logoBrandDefault;
                }}
              />
            </div>
            <p className='text-sm font-regular text-98A2B3 white-space-nowrap'>{brand}</p>
          </div>
        );
      },
      filter: 'agSetColumnFilter',
      filterParams: {
        // values: listBrand?.map(item => item.title) || undefined,
        buttons: ['apply', 'reset'],
        applyButton: true,
        closeOnApply: true,
      },
      floatingFilter: true,
      flex: 1
    },
    {
      headerName: 'Phân khúc',
      field: 'segment',
      colId: 'segment',
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-segment'>{params.value || NO_DATA}</div>;
      },
      flex: 1
    },
    {
      headerName: 'Dòng xe',
      field: 'typeCar',
      colId: 'typeCar',
      flex: 1,
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      }
    },

    {
      headerName: 'Mẫu xe',
      field: 'modelVehicleTitle',
      colId: 'modelVehicleTitle',
      flex: 1,
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-segment'>{params.value || NO_DATA}</div>;
      },
    },

    {
      headerName: 'Nhóm sản phẩm',
      field: 'groupVehicleTitle',
      colId: 'groupVehicleTitle',
      flex: 1,
      sortable: true,
      comparator: (valueA: string, valueB: string) => {
        return valueA.length - valueB.length;
      },
      cellRenderer: (params: any) => {
        return <div className='td-card-segment'>{params.value || NO_DATA}</div>;
      },
    },
    {
      headerName: 'Năm sản xuất',
      field: 'yearManufacture',
      colId: 'yearManufacture',
      cellRenderer: (params: any) => {
        return <div className='td-card-segment'>{params.value || NO_DATA}</div>;
      },
      flex: 1,
      // Bỏ sorter nếu không cần
    }
  ], [])); // Thêm dependencies nếu cần

  const [infoCar, setInfoCar] = useState<carApi.ICarEdit>()
  const [detailCar, setDetailCar] = useState<carApi.ICarEdit>()

  const [listCar, setListCar] = useState<DataType[]>([])
  const [listBrand, setListBrand] = useState<listBrand[]>(arrBrand)

  const defaultColumnsShow = ['action', 'imgCar', 'clCar', 'codeCar', 'nameCar', 'logo', 'segment', 'typeCar', 'yearManufacture', 'codeB7', 'modelVehicleTitle', 'groupVehicleTitle'] as any



  //Danh sách xe
  const gListCar = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {
    pushLoading(true)
    const result = await carApi.getListCar(pageSize, pageCurent, defaulFilter?.search, defaulFilter?.typeVehicleId, defaulFilter?.categoryCarId)
    if (result?.status) {

      setListCar(convertData(result.data))
      setPagination({ current: pageCurent, total: result.total, pageSize })
      setPaginationTmp(pageCurent)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const convertData = (data: carApi.ICar[]) => {
    const convertData = data.map((item) => ({
      key: item.id,
      imgCar: URL_CAR + item.image,
      clCar: item.typeVehicle,
      codeCar: item.code,
      nameCar: item?.title,
      logoBrand: URL_CAR_CATEGORY + item.categoryCarImage,
      brand: item.categoryCar,
      segment: item.segmentsVehicle,
      typeCar: item.carLines,
      yearManufacture: item.yearCreate ? item.yearCreate.toString() : null,
      versionCar: item.version,
      codeB7: item.codeB7,
      modelVehicleTitle: item.modelVehicleTitle,
      groupVehicleTitle: item.groupVehicleTitle,
    }))
    return convertData
  }

  const onPaginationChange: PaginationProps['onChange'] = (pageNumber, pageSize) => {
    setPaginationTmp(pageNumber);
    setPagination((prev) => ({ ...prev, current: pageNumber, pageSize }))
    gListCar(pageNumber, pageSize)
  }

  const gCarLines = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLTypeVehicle()
    if (result?.status) {
      setTypeVehicle(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  //thương hiệu
  const gCLCarCompany = async () => {
    pushLoading(true)
    const result = await selectOptionsApi.getCLCategoryCar(
      undefined, defaulFilter?.typeVehicleId
    )
    if (result?.status) {
      setSLCategoryCar(result.data)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  // Thông tin xe
  const gInfoCar = useThrottle(async (id: number, isview: boolean = true) => {
    pushLoading(true)
    const result = await carApi.getInfoCar(id)
    if (result?.status) {
      setInfoCar(result.data)
      if (isview) {
        setIsOpenViewCar(true)
      } else {
        setIsOpenEditCar(true)
      }
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // Chi tiết tin xe
  const gDetailCar = useThrottle(async (id: number) => {
    pushLoading(true)
    const result = await carApi.getInfoCar(id)
    if (result?.status) {
      setDetailCar(result.data)
      setIsOpenDetailCar(true)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  const onSubmitFormModalAdd = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setIsOpenCreateCar(false);
      pushToast(errorMessage, "success")
      gListCar(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(errorMessage, "warning")
    }
  }

  const onSubmitFormModalEdit = (iSsuccess: boolean, errorMessage?: string) => {
    if (iSsuccess) {
      setIsOpenEditCar(false);
      pushToast(errorMessage, "success")
      gListCar(pagination.current, pagination.pageSize)
    }
    else {
      pushToast(errorMessage, "warning")
    }
  }

  const openModalDeleteCar = (id: number) => {
    setIdCar(id)
    setIsOpenDeleteVehicle(true)
  }

  const closeModalDeleteCar = () => {
    setIdCar(undefined)
    setIsOpenDeleteVehicle(false)
  }

  const onConfirmDelete = async () => {
    pushLoading(true)
    const result = await carApi.deleteCar(Number(idCar))
    if (result?.status) {
      pushToast("Xóa xe thành công", "success")
      closeModalDeleteCar()

      setselectedIdCar(new Set())
      gListCar(pagination.current, pagination.pageSize)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);


  };
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const onChangeTB: TableProps<DataType>['onChange'] = (pagination, filters, sorter, extra) => {
    console.log('params', pagination, filters, sorter, extra);
  };
  const handleChangeCheck = (valueCheck: number) => {
    setListBrand(
      prevState => {
        const updatedList = [...prevState];
        updatedList[valueCheck].checked = !updatedList[valueCheck].checked;
        return updatedList;
      }
    )
  }
  const reSetAllChecked = () => {
    setListBrand(prevState =>
      prevState.map(item => ({
        ...item,
        checked: false
      }))
    );
  }

  const isAnyChecked = listBrand.some(item => item.checked);

  const glistByExcel = useThrottle(async () => {
    pushLoading(true)
    const result = await carApi.getListCar(LIMIT_EXPORT_EXCEL, 1, filterName)
    if (result?.status) {
      formattedDataExcel(result.data, result?.message)
    } else {
      pushToast(result?.message, "warning")
    }
    pushLoading(false)
  }, 1000)

  // exel được chọn
  const glistSelectedExel = () => {
    const selectedData = listCar.filter((item) => selectedIdCar.has(Number(item.key)))
    formattedDataSelectedExcel(selectedData)
  }

  const formattedDataExcel = (data: carApi.ICar[], message?: string) => {
    pushLoading(true)
    const formattedData = data.map((item) => {
      return {
        "Chủng loại": item.typeVehicle || NO_DATA,
        "Mã xe": item.code || NO_DATA,
        "Tên xe": item.title || NO_DATA,
        "Thương hiệu": item.categoryCar || NO_DATA,
        "Phân khúc": item.segmentsVehicle || NO_DATA,
        "Dòng xe": item.carLines || NO_DATA,
        "Năm sản xuất": item.yearCreate || NO_DATA,
        "Phiên bản": item.version || NO_DATA,
        "Mã xe B7": item.codeB7 || NO_DATA,
        "Mẫu xe": item.modelVehicleTitle || NO_DATA,
        "Nhóm sản phẩm": item.groupVehicleTitle || NO_DATA,

      }
    }
    );
    exportExcel(formattedData, message)
    pushLoading(false)
  }

  const formattedDataSelectedExcel = (data: DataType[]) => {
    pushLoading(true)
    const formattedDataSelected = data.map((item) => {
      return {
        "Chủng loại": item.clCar || NO_DATA,
        "Mã xe": item.codeCar || NO_DATA,
        "Tên xe": item.nameCar || NO_DATA,
        "Thương hiệu": item.brand || NO_DATA,
        "Phân khúc": item.segment || NO_DATA,
        "Dòng xe": item.typeCar || NO_DATA,
        "Năm sản xuất": item.yearManufacture || NO_DATA,
        "Phiên bản": item.versionCar || NO_DATA,
        "Mã xe B7": item.codeB7 || NO_DATA,
        "Mẫu xe": item.modelVehicleTitle || NO_DATA,
        "Nhóm sản phẩm": item.groupVehicleTitle || NO_DATA,
      }
    }
    );
    exportExcel(formattedDataSelected, "Danh sách xe được chọn")
    pushLoading(false)
  }

  const handleFile = (file: any) => {
    setFileData(file)
  }

  const handleUpload = async (type: string): Promise<ResponseSuccessDataError> => {
    setType(type)
    pushLoading(true)
    const result = await uploadFileCar(fileData)
    if (result?.status) {
      pushToast(result?.message, "success")
    }
    pushLoading(false)
    return result
  }

  const checkedList = localStorage.getItem('carListColums') ? JSON.parse(localStorage.getItem('carListColums') as string) : [...defaultColumnsShow] as any

  // Sử dụng colId thay vì key
  const columnDefsWithVisibility = useMemo(() => {
    return columnDefs.map((item: any) => ({
      ...item,
      hide: !checkedList.includes(item.colId) // Sử dụng hide property của AG Grid
    }));
  }, [columnDefs, checkedList]);


  const handleCloseSetting = (value: any, isChange: boolean, reorderedColumns: any[]) => {
    if (isChange) {
      localStorage.setItem('carListColums', JSON.stringify(value));
      // Cập nhật trạng thái cột với các cột được sắp xếp lại, bảo toàn thuộc tính ẩn
      const updatedColumns = reorderedColumns.map((col) => ({
        ...col,
        hidden: !value.includes(col.colId),
      }));
      setColumnDefs(updatedColumns);
    }
    setIsOpenAddvance(false);
  };

  // Trong Ag-Grid, thêm onSelectionChanged
  const onSelectionChanged = (event: any) => {
    const selectedNodes = event.api.getSelectedNodes();
    const selectedIds = new Set<number>(
      selectedNodes.map((node: any) => Number(node.data.key))
    );
    setselectedIdCar(selectedIds);
  };

  useEffect(() => {
    gListCar()

  }, [defaulFilter])
  return (
    <Layout>
      <ModalCreateCar
        isOpen={isOpenCreateCar}
        sLCategoryCar={sLCategoryCar}
        onSubmitFormModal={onSubmitFormModalAdd}
        closeModal={() => setIsOpenCreateCar(!isOpenCreateCar)}
      />
      <ModalEditCar
        isOpen={isOpenEditCar}
        infoCar={infoCar}
        sLCategoryCar={sLCategoryCar}
        onSubmitFormModal={onSubmitFormModalEdit}
        closeModal={() => setIsOpenEditCar(!isOpenEditCar)}
      />
      <ModalViewCar
        isOpen={isOpenViewCar}
        infoCar={infoCar}
        sLCategoryCar={sLCategoryCar}
        closeModal={() => setIsOpenViewCar(!isOpenViewCar)}
      />
      <ModalManagerSegment
        isOpen={isOpenSegment}

        closeModal={() => setIsOpenSegment(!isOpenSegment)}
      />
      <DrawerAddvance
        isOpen={isOpenAddvance}
        columns={columnDefs}
        defaultColumnsShow={defaultColumnsShow}
        localStorageValue="carListColums"

        onClose={(value, isChange, reorderedColumns) => { handleCloseSetting(value, isChange, reorderedColumns) }}
        closeDrawer={() => setIsOpenAddvance(!isOpenAddvance)}
      />
      <DrawerInfoCar
        isOpen={isOpenDetailCar}
        detailCar={detailCar}
        closeDrawer={() => setIsOpenDetailCar(!isOpenDetailCar)}
      />
      <ModalDeleteManager
        isOpen={IsOpenDeleteVehicle}
        closeModal={closeModalDeleteCar}
        onConfirm={onConfirmDelete}
        title='Bạn có chắc chắn xóa xe này'
        titleDelete='Xóa xe'
        content='Xe và dữ liệu liên quan sẽ bị xóa vĩnh viễn không thể khôi phục'
      />
      <ImportDataColorCar
        show={openModalUpload}
        fileData={fileData}
        linkExamplPre={`${API_URL}uploads/fileExcel/car/Danhsachxe.xlsx`}
        type={"dataCarError"}

        setFileData={setFileData}
        handleUpload={() => handleUpload(type)}
        handleFile={handleFile}
        gListCarColor={gListCar}
        modalClose={() => setOpenModalUpload(false)}
      />
      <Breadcrumb
        items={[
          {
            title: 'THACO AUTO CRM',
          },
          {
            title: <a href="/">Quản lý danh mục xe</a>,
          },
          {
            title: 'Danh sách xe',
          },
        ]}
      />
      <div className='title-page'>
        Danh sách xe
      </div>
      <div className='d-flex gap-3 pb-18-px vehicle-list-filter'>
        <div className="w-215-px border-F2F4F7 bg-FCFCFD rounded-2 d-flex align-center pl-3  py-1 h-8 justify-between overflow-hidden">
          <Input
            placeholder="Tìm kiếm theo tên xe và mã xe"
            className="bg-FCFCFD text-sm border-none custom-input-focus none-focus-erro font-regular p-none-input place-holder-input-667085 hover-none"
            value={defaulFilter?.search}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, search: e.target.value })}
          />
          <div className=" border-l-F2F4F7 h-full d-flex align-center">
            <SearchOutlined className="text-sm text-98A2B3 px-9-px" />
          </div>
        </div>
        <div className='w-215-px'>
          <Select
            allowClear
            placeholder="Loại xe"
            options={fommatSelectOption(typeVehicle)}
            value={defaulFilter?.typeVehicleId}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, typeVehicleId: e })}
            className="custome-select rs-select"

            popupMatchSelectWidth={false}

          />
        </div>
        <div className='w-215-px'>
          <Select
            allowClear
            placeholder="Thương hiệu"
            options={fommatSelectOption(sLCategoryCar)}
            value={defaulFilter?.categoryCarId}
            onChange={(e) => setDefaultFilter({ ...defaulFilter, categoryCarId: e })}
            className="custome-select rs-select"

            popupMatchSelectWidth={false}

          />
        </div>
        <button className={`border-EAECF0 bg-white rounded-6-px w-106-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(download)}`}
          onClick={selectedIdCar.size ? glistSelectedExel : glistByExcel}
        >
          <DownloadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Xuất DS</span>
        </button>
        <button
          className={`border-EAECF0 bg-white rounded-6-px w-111-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save ${checkDisabledPermission(upload)}`}
          onClick={() => setOpenModalUpload(true)}
        >
          <UploadOutlined className='text-sm text-344054' />
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Nhập DS</span>
        </button>
        <button className='border-EAECF0 bg-white rounded-6-px w-146-px py-2 h-8 d-flex justify-center align-center gap-10-px shadow-btn-save'
          onClick={() => setIsOpenSegment(!isOpenSegment)}
        >
          <span className='text-sm fw-400 font-regular text-344054 white-space-nowrap'>Quản lý thuộc tính</span>
        </button>
        <button className={`border-none bg-096DD9 rounded-6-px  py-2 h-8 d-flex justify-center align-center gap-10-px w-107-px ${checkDisabledPermission(add)}`}
          onClick={() => setIsOpenCreateCar(true)}
        >
          <PlusOutlined className='text-sm text-white' />
          <span className='text-sm fw-400 font-regular text-white white-space-nowrap'>Tạo mới</span>
        </button>
        <button className='border-EAECF0 bg-white rounded-2  w-8  h-8  shadow-btn-save'
          onClick={() => setIsOpenAddvance(true)}
        >
          <SettingOutlined className='text-sm text-344054' />
        </button>
      </div>
      <div className={`order-history-card__body custom-page-css flex flex-col flex-1 justify-between`}>
        <div className="ag-theme-alpine custom-table-ag custom-css-table" style={{ width: '100%', height: 600 }}>
          <AgGridReact
            className="my-auto-height-grid"
            getRowStyle={(params: any) => ({
              backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
            })}
            rowData={listCar}
            rowHeight={55}
            columnDefs={columnDefsWithVisibility}
            rowSelection={{ mode: 'multiRow' }}
            // rowSelection="multiple"
            onSelectionChanged={onSelectionChanged}
            overlayNoRowsTemplate={NodataTable}
            suppressDragLeaveHidesColumns={true}

            // Thêm các props sau để cải thiện scroll
            rowBuffer={20}
            maxBlocksInCache={10}
            infiniteInitialRowCount={1000}
          />

        </div>
        <ConfigProvider locale={viVN}>
          <div className="pagination-block">
            <Pagination showSizeChanger current={pagination.current} pageSize={pagination.pageSize} total={pagination.total}
              itemRender={(page, type, originalElement) => {
                // Chỉ custom khi là nút số trang
                if (type === 'page') {
                  return <span>{formatNumber(page)}</span>;
                }
                // prev / next / jump-prev / jump-next giữ nguyên
                return originalElement;
              }}
              showTotal={(total) => `Tổng cộng ${dataPagination(pagination.total, pagination.pageSize,
                pagination.current).totalPage} trang`}
              className='rs-pagination'
              onChange={onPaginationChange}
            />
          </div>
        </ConfigProvider>
      </div>
    </Layout>
  );
}

export default VehicleList;
